import React from 'react';
import { MainLayout } from '../components/MainLayout';
import { AccrualPage } from '../components/accrual/AccrualPage';

export function Accrual() {
  return (
    <MainLayout>
      <AccrualPage />
    </MainLayout>
  );
}